/**
 * The plaintext of the key created most recently, held in memory ONLY so the setup page can
 * fill it in. Not in router state (history.state is persisted by the browser across reloads),
 * not in storage. A reload forgets it, by design.
 */
let current: { key: string; alias: string | null } | null = null;
export const secretMemory = {
  set: (key: string, alias: string | null) => (current = { key, alias }),
  get: () => current,
  clear: () => (current = null),
};
